import { FetchImportedInvoiceByIdResponseData } from '../query-api'
import { ImportedInvoice } from '../types/importedInvoice'
import { getImportedInvoiceIntegrationStatus } from './getImportedInvoiceIntegrationStatus'

export const getImportedInvoice = (invoice: FetchImportedInvoiceByIdResponseData): ImportedInvoice => ({
  approved: invoice.approved ?? null,
  extraction: {
    counterparty: invoice.counterparty ?? null,
    header: invoice.header ?? null,
    lines: invoice.lines ?? null,
    proposal: invoice.proposal ?? null,
  },
  fileId: invoice.fileId,
  fileName: invoice.filename ?? '',
  integrationRejectCode: invoice.cpaToolsIntegrationRejectCode ?? undefined,
  integrationStatus: getImportedInvoiceIntegrationStatus(invoice.cpaToolsIntegrationStatus),
  paymentStatus: invoice.paymentStatus ?? undefined,
  status: invoice.status,
  uploadDate: invoice.uploadDate,
})
